import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Modal } from 'antd';
import { useSaveMealPlan, useUploadMealPlanImage } from 'hooks';
import { showUploadError } from 'apis';

import { TMealPlanFormData } from 'interfaces/mealPlan';

import MealPlanForm from './components/MealPlanForm';
import { buildMealPlanRequest } from './mealPlanRequest';
import { PageWrapper } from './styles';

const { useForm } = Form;

const MealPlanAddPage = () => {
  const navigate = useNavigate();
  const [form] = useForm();
  const { mutateAsync: saveMealPlan } = useSaveMealPlan();
  const uploadMealPlanImage = useUploadMealPlanImage();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async (values: TMealPlanFormData) => {
    const { mealPlanImage } = values;
    const items = values?.isUseMealPlanItem ? values?.items : [];

    setIsSubmitting(true);
    try {
      const uploadedImageUrl = mealPlanImage instanceof File ? await uploadMealPlanImage(mealPlanImage) : null;
      await saveMealPlan(buildMealPlanRequest({ ...values, items }, { uploadedImageUrl }));
    } catch (error) {
      showUploadError(error);
      return;
    } finally {
      setIsSubmitting(false);
    }

    Modal.info({
      className: 'info-handler-modal',
      content: `식단표가 등록되었습니다.`,
      icon: null,
      okText: '확인'
    });
    navigate('/mealPlan');
  };

  return (
    <PageWrapper>
      <MealPlanForm form={form} onSubmit={handleSubmit}>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'end', marginTop: '24px' }}>
          <Button className="default-button-style">취소</Button>
          <Button className="default-button-style" type="primary" htmlType="submit" loading={isSubmitting}>
            저장하기
          </Button>
        </div>
      </MealPlanForm>
    </PageWrapper>
  );
};

export default MealPlanAddPage;
